import { Component } from '@angular/core';

@Component({
  selector: 'app-delivery-order-detail',
  standalone: false,
  
  templateUrl: './delivery-order-detail.component.html',
  styles: ``
})
export class DeliveryOrderDetailComponent {

}
